import { ReactElement } from 'react';

import { Stack, Switch, Typography } from '@mui/material';
import { ProfileContainer, ResetPasswordButton } from './Filter.components';
import { ControlledInputs, Grid, PrimaryButton } from '@/components';
import { useUserProfileFormContext } from '../hooks';

export const Profile = (): ReactElement => {
  const form = useUserProfileFormContext();

  return (
    <Stack alignItems="center">
      <ProfileContainer>
        <Typography fontSize={24}>Profile</Typography>
        <Stack gap={2}>
          <Stack
            direction="row"
            justifyContent={'space-between'}
            alignItems="center"
            px={1}
            pb={2}
          >
            <Stack direction="row" gap={2} alignItems="center">
              <svg
                width="67"
                height="67"
                viewBox="0 0 67 67"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M66.0418 33.5C66.0418 43.3957 61.625 52.2618 54.6523 58.2317C48.763 63.2818 41.2582 66.0528 33.5002 66.0417C25.4239 66.0417 18.037 63.1011 12.3481 58.2317C8.77309 55.1791 5.90328 51.3868 3.93685 47.1169C1.97043 42.8469 0.954255 38.201 0.958509 33.5C0.958509 15.5282 15.5283 0.958374 33.5002 0.958374C51.472 0.958374 66.0418 15.5282 66.0418 33.5ZM45.3335 23.1459C45.3335 20.0075 44.0868 16.9976 41.8676 14.7784C39.6484 12.5593 36.6386 11.3125 33.5002 11.3125C30.3618 11.3125 27.3519 12.5593 25.1327 14.7784C22.9136 16.9976 21.6668 20.0075 21.6668 23.1459C21.6668 26.2843 22.9136 29.2941 25.1327 31.5133C27.3519 33.7325 30.3618 34.9792 33.5002 34.9792C36.6386 34.9792 39.6484 33.7325 41.8676 31.5133C44.0868 29.2941 45.3335 26.2843 45.3335 23.1459ZM52.7293 51.9157V51.25C52.7293 48.1116 51.4826 45.1018 49.2634 42.8826C47.0443 40.6634 44.0344 39.4167 40.896 39.4167H26.1043C22.9659 39.4167 19.9561 40.6634 17.7369 42.8826C15.5177 45.1018 14.271 48.1116 14.271 51.25V51.9157C14.8824 52.5527 15.5234 53.1591 16.1939 53.735C21.0114 57.8686 27.1524 60.136 33.5002 60.125C37.0945 60.1319 40.6527 59.4077 43.9584 57.9964C47.2641 56.5851 50.2482 54.5163 52.7293 51.9157Z"
                  fill="#CBCACA"
                />
              </svg>
              <Stack>
                <Typography fontSize={16} fontWeight={700}>
                  ByeWind
                </Typography>
                <Typography fontSize={12}>byewind@twitter.com</Typography>
              </Stack>
            </Stack>
          </Stack>
          <Grid columns={2} gap={50}>
            <ControlledInputs.TextField
              placeholder="Enter your First Name"
              ControllerProps={{
                control: form.control,
                name: 'firstName',
              }}
              label="First Name"
            />
            <ControlledInputs.TextField
              placeholder="Enter your Last Name"
              ControllerProps={{
                control: form.control,
                name: 'lastName',
              }}
              label="Last Name"
            />
          </Grid>
          <ControlledInputs.TextField
            placeholder="Enter your email address"
            ControllerProps={{
              control: form.control,
              name: 'email',
            }}
            label="Email"
          />
        </Stack>

        <Stack gap={2}>
          <Typography fontSize={24}>Password and security</Typography>
          <Grid columns={2} gap={50}>
            <ResetPasswordButton>
              Reset Password
              <svg
                width="24"
                height="9"
                viewBox="0 0 24 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.6509 4.84757C23.8461 4.65231 23.8461 4.33573 23.6509 4.14047L20.4689 0.958485C20.2736 0.763222 19.9571 0.763222 19.7618 0.958485C19.5665 1.15375 19.5665 1.47033 19.7618 1.66559L22.5902 4.49402L19.7618 7.32245C19.5665 7.51771 19.5665 7.83429 19.7618 8.02955C19.9571 8.22481 20.2736 8.22481 20.4689 8.02955L23.6509 4.84757ZM0.200195 4.49402L0.200195 4.99402L23.2973 4.99402V4.49402V3.99402L0.200195 3.99402L0.200195 4.49402Z"
                  fill="currentColor"
                />
              </svg>
            </ResetPasswordButton>

            <Stack direction="row" alignItems="center" gap={2}>
              <ResetPasswordButton>
                Two-factor Authentication
              </ResetPasswordButton>
              <ControlledInputs.Switch
                ControllerProps={{
                  control: form.control,
                  name: 'twoFactorEnabled',
                }}
              />
            </Stack>
          </Grid>
        </Stack>
        <Stack direction="row">
          <PrimaryButton type="submit">Save</PrimaryButton>
        </Stack>
      </ProfileContainer>
    </Stack>
  );
};
